import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-installation-choice-dialog",
  templateUrl: "./installation-choice-dialog.component.html",
  styleUrls: ["./installation-choice-dialog.component.scss"],
  standalone: false,
})
export class InstallationChoiceDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<InstallationChoiceDialogComponent>,
  ) {}

  chooseExtension(): void {
    this.dialogRef.close("extension");
  }

  chooseMarketplace(): void {
    this.dialogRef.close("marketplace");
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
